<template>
    <el-dialog
        :show-close="false"
        class="policy-dialog"
        ref="policyDialog"
        :center="true"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="dialogPolicyVisible"
    >
        <div>
            <h2>Privacy Policy</h2>
            <p>
                MyCorwin.com, a subsidiary of Corwin Design & Graphics
                Corporation (“CORWIN”) is committed to protecting your privacy.
                That is because we base our business on the trust you place in
                us. This policy describes our practices regarding personal and
                account information collected through our Web site. In this
                policy, "personal and account information" means your name,
                company name, account number, address, telephone number, and
                e-mail address plus any other information that personally
                identifies you, including your industry, the number of employees
                at your company, and purchase history, or would permit us to
                contact you, and "we" and "us" means MyCorwin.com (“CORWIN”) as
                well as its affiliated companies.
            </p>
            <p>
                We reserve the right to modify this privacy policy from time to
                time; the effective date noted above will indicate the date that
                this policy was last updated. You should visit our Web site
                periodically to review any changes.
            </p>
            <h2>How much information must I share?</h2>
            <p>
                The amount and type of information we collect from you depends
                on your activities and use of our Web site. Below, we explain
                what information we collect.
            </p>
            <h2>When you browse our Web site</h2>
            <p>
                IP address - We collect your IP address to measure our Web site
                traffic and to help provide a relevant shopping experience.
            </p>
            <p>
                Referral Web site. If you come to our Web site via a link, we
                collect the location of the link that referred you.
            </p>
            <p>
                Browser type. We collect information about the browser you are
                using to help optimize our Web site for visitors.
            </p>
            <p>
                Movements through our Web site. We keep track of pages you visit
                to help provide you with a more personalized shopping
                experience.
            </p>
            <h2>
                Is my personal or account information used for any other
                purpose?
            </h2>
            <p>
                We may use your personal and account information to provide
                products or services you have requested, respond to a
                communication from you, contact you, and as otherwise described
                in this policy. We may occasionally send you promotional or
                product information. The privacy and protection of your personal
                information is vitally important to us. CORWIN does not make
                personal information available to any third parties without your
                permission. CORWIN usage statistics are provided in the
                aggregate only and do not include any personally identifiable
                information about any individual user.
            </p>
            <p>
                We may also analyze and act upon your personal and account
                information as part of our standard business practices. We
                occasionally purchase from third parties commercial information
                such as company size, number of employees and annual sales of
                other companies. We may use this commercial information along
                with your personal and account information to customize our
                offerings to you, as well as for our internal use.
            </p>
            <p>
                In addition, in order to measure how we are doing and to better
                understand how we can improve our product offerings, we or one
                of our service providers or strategic partners may contact you
                by telephone or e-mail and solicit your participation in
                research.
            </p>
            <h2>When you make purchases through our Web site</h2>
            <p>
                We collect your name, address and payment information to process
                your order. However, you may provide credit card and purchase
                order numbers by telephone.
            </p>
            <p>
                We collect information contained in "cookies," such as your
                purchases and log in data, to personalize your shopping
                experience. Your browser must be set to accept cookies if you
                wish to add items to a shopping cart.
            </p>
            <h2>When you communicate with us through our Web site</h2>
            <p>
                We collect your e-mail address and the other information that
                you provide in order to respond to your communication.
            </p>
            <h2>
                When you enter contests, participate in surveys, or register for
                other activities on our Web site
            </h2>
            <p>
                We collect your name, e-mail address and telephone number, and
                the other information that is required for entry or
                participation, which varies depending on the activity.
            </p>
            <h2>When you create an Account on our Web site</h2>
            <p>
                We collect your user name, password, e-mail address to protect
                your Account. You can help us ensure your privacy by not sharing
                your user name or password.
            </p>
            <h2>
                When you subscribe to our e-mail update or newsletter through
                our Web site
            </h2>
            <p>
                You must submit your e-mail address to subscribe to our e-mail
                updates or newsletter. We use your Account information in
                connection with your subscription.
            </p>
            <h2>
                When you e-mail product information to a friend or colleague
                through our Web site
            </h2>
            <p>
                We collect your e-mail address and the e-mail address of the
                person to whom you are sending the product information.
            </p>
            <h3>
                If you become our customer, we may send you updates on important
                information about our company and services.
            </h3>
            <p>
                Will my personal and account information be provided to any
                other party? We restrict access to your personal and account
                information to those who need access to use it as set forth in
                this policy. Only authorized personnel are permitted to see your
                Account password. Your other personal and account information
                may be disclosed to third parties in limited circumstances. For
                example, we may share your personal and account information with
                our service providers and strategic partners and with suppliers
                and other entities involved in transactions you have initiated.
                We may disclose your personal and account information to respond
                to subpoenas, court orders, or other legal process, as required
                by law, or to establish or exercise our legal rights or defend
                against legal claims. Your personal and account information may
                also be disclosed in connection with a sale of some or all of
                our business or a merger with another company.
            </p>
            <h2>How do you protect my personal and account information?</h2>
            <p>
                We use 128-bit encryption technology and Secure Socket Layers
                ("SSL") in all areas where you're personal and account
                information is required. Which verifies that our Web site is
                authentic and that we use SSL security.
            </p>
            <h2>How can I correct inaccurate information?</h2>
            <p>
                You may correct some personal and account information maintained
                in your Account through your Account. To correct any other
                information, please contact CORWIN by e-mailing us at
                support@corwindesign.com.
            </p>
            <p>MyCorwin.com & Corwin Design & Graphics Corporation © 2019</p>
            <el-checkbox class="mt-10" v-model="form.dont_show_again"
                >Do not show this message again</el-checkbox
            >
            <div class="mt-20">
                <el-button
                    type="success"
                    @click="agreeToPolicy"
                    :loading="form.busy && loadingButton === 'agree'"
                    :disabled="form.busy"
                >
                    Yes, I agree
                </el-button>
                <el-button
                    type="default"
                    @click="disAgreeToPolicy"
                    :loading="form.busy && loadingButton === 'disagree'"
                    :disabled="form.busy"
                >
                    No, I don't agree
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import * as Actions from "../store/constants/actions";
import * as Mutations from "@/store/constants/mutations";

export default {
    name: "PolicyDialog",
    data() {
        return {
            dialogPolicyVisible: false,
            loadingButton: null,
            form: new Form({
                dont_show_again: false,
            }),
        };
    },
    mounted() {
        if (!this.$store.state.user) {
            return;
        }
        this.dialogPolicyVisible = this.$store.state.require_agree_policy;
    },
    methods: {
        agreeToPolicy() {
            this.loadingButton = "agree";
            App.post("/web-api/auth/agree-to-policy", this.form).then(() => {
                this.dialogPolicyVisible = false;
                this.$store.commit(Mutations.AGREED_POLICY);
                this.$store.dispatch(Actions.UPDATE_USER);
            });
        },
        disAgreeToPolicy() {
            this.loadingButton = "disagree";
            App.post("/logout", this.form).then(() => {
                location = "/login";
            });
        },
        show() {
            this.dialogPolicyVisible = true;
        },
    },
};
</script>

<style lang="scss">
.policy-dialog {
    .el-dialog__header {
        padding: 0;
    }
}
</style>
